import React, { useEffect } from 'react'
import { onPageEnter } from 'lib/tracking/pageEnter'
import { GetServerSideProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { parseLocale } from 'lib/constants/localization'
import styled from 'styled-components'
import theme from 'stories/utils/theme'
import StrapiService from 'services/StrapiService'
import { BlocksRenderer, type BlocksContent } from '@strapi/blocks-react-renderer'
import { ArticleProgress, ContentWrapper } from 'components/feature/Article/Article.styles'
import Meta from 'components/modules/SEO/Meta'

const Container = styled.div`
    background-color: ${theme.colors.white};
    min-height: 100vh;
`

const Article = styled.article`
    padding: 25px;
    position: relative;
    @media (max-width: 750px) {
        padding: 10px;
    }
`

interface Props {
    pageContent: BlocksContent
}

function Legal({ pageContent }: Props) {
    const title = pageContent?.length ? (pageContent[0].children[0] as { text: string })?.text : ''

    useEffect(() => {
        onPageEnter()
    }, [])

    return (
        <Container>
            <section>
                <Meta title={title} description="" noIndex />

                <Article>
                    <ArticleProgress />
                    <ContentWrapper>
                        <BlocksRenderer content={pageContent} />
                    </ContentWrapper>
                </Article>
            </section>
        </Container>
    )
}

export const getServerSideProps: GetServerSideProps<Props> = async (context) => {
    if (!context.params || typeof context.params.slug !== 'string') {
        return { notFound: true }
    }

    const intefaceLanguageCode = parseLocale(context.locale).strapiLanguage

    const translations = await serverSideTranslations(intefaceLanguageCode)

    const legalPageContent = await StrapiService.getLegalPage(context.params.slug, intefaceLanguageCode).catch((error) => {
        throw error
    })

    if (!legalPageContent) {
        return { notFound: true }
    }

    return {
        props: {
            ...translations,
            pageContent: legalPageContent,
        },
    }
}

export default Legal
